// Styling for the claim outcome (bead hf-e6-commitments-coverage-udt.4.2).
//
// Everything here is design tokens — this panel belongs to the product, unlike the
// dev persona bar which deliberately does not. The layout is plain because the moment
// is: a short message, the plan's own numbers, and a way onward.
//
// No animation on appearance. A panel that slides or flashes reads as an alert, and
// the whole point of this surface is that nothing has gone wrong.

export const claimStylesheet = String.raw`
  .claim-outcome {
    display: grid;
    gap: var(--herefor-space-4);
    max-inline-size: 42rem;
  }

  /* A status message lays its children out in a row; the panel needs one child that
     then stacks its own lines. */
  .claim-outcome__lines {
    display: grid;
    gap: var(--herefor-space-2);
  }

  .claim-outcome__action {
    margin: var(--herefor-space-2) 0 0;
  }

  .claim-outcome__title {
    margin: 0;
    font-size: var(--herefor-font-size-lg);
    font-weight: var(--herefor-font-weight-semibold);
    line-height: var(--herefor-line-height-tight);
  }

  .claim-outcome__body,
  .claim-outcome__coverage,
  .claim-outcome__nothing-else {
    margin: 0;
  }

  /* The plan's own count, given a little weight: it is the explanation, not a note. */
  .claim-outcome__coverage {
    font-weight: var(--herefor-font-weight-medium);
  }

  .claim-outcome__still-needed {
    padding: var(--herefor-space-4);
    background: var(--herefor-color-surface-subtle);
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-md);
  }

  .claim-outcome__still-needed-title {
    margin: 0 0 var(--herefor-space-3);
    font-size: var(--herefor-font-size-md);
    font-weight: var(--herefor-font-weight-semibold);
  }

  .claim-outcome__needs {
    display: grid;
    gap: var(--herefor-space-2);
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .claim-outcome__needs li {
    display: flex;
    flex-wrap: wrap;
    gap: var(--herefor-space-2);
    align-items: baseline;
  }

  .claim-outcome__need-when {
    color: var(--herefor-color-text-muted);
  }

  .claim-outcome__nothing-else {
    color: var(--herefor-color-text-muted);
  }
`;
